import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
export function PurchaseTerms() {
  return <section className="bg-white px-5 py-16 md:py-24" aria-labelledby="terms-title" data-id="element-272" data-mp="2ym0gfeuf5fmi">
      <div className="mx-auto max-w-3xl text-center" data-id="element-273" data-mp="33js6s4ff0tol">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-heal-50 text-heal ring-8 ring-heal-50/60" data-id="element-274" data-mp="38b0f0x50e906">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-275" data-mp="3d9brlfmouxm3" />
        </span>
        <p className="mt-6 font-display text-xs font-extrabold uppercase tracking-[0.14em] text-pulse sm:text-sm" data-id="element-276" data-mp="3hb6yr0raw57s">
          Your purchase terms
        </p>
        <h2 id="terms-title" className="mt-3 font-display text-3xl font-black leading-tight text-navy-900 sm:text-4xl text-balance" data-id="element-277" data-mp="3m98jdq4dkcld">
          Review the Complete ECG Interpretation Blueprint™ and Decide Whether It Fits Your Learning Needs
        </h2>
        <div className="mt-6 space-y-4 text-lg leading-relaxed text-muted" data-id="element-278" data-mp="1wx6cliz4702x">
          <p data-id="element-279" data-mp="3f8tscg6g9ecn">I want you to know exactly what you’re purchasing.</p>
          <p data-id="element-280" data-mp="3fa4uyco5sg26">
            Your collection includes six educational volumes, five complementary bonuses, and practical ECG learning
            resources. Everything is designed to support structured independent study.
          </p>
          <p data-id="element-281" data-mp="31hf680h8wx1d">
            Before completing your purchase, please review the delivery details and refund policy displayed at
            checkout. If your purchase is covered by a seven-day satisfaction guarantee, the published refund terms
            will explain how to request a refund and which conditions apply.
          </p>
          <p className="font-semibold text-ink" data-id="element-282" data-mp="3p5585g590mbu">
            My goal is to make the contents and purpose of this collection clear so you can make an informed decision.
          </p>
        </div>
      </div>
      <SectionCTA label="Get the ECG Interpretation Blueprint™ today" data-id="element-283" data-mp="2dsvx5iqdgg88" />
    </section>;
}